import CardWithIcon from './Content/CardWithIcon/CardWithIcon';
import IconFromSVG from './Icon/IconFromSVG/IconFromSVG';

export default {
  CardWithIcon,
  IconFromSVG,
};
